import { featureRegistry } from "./registry";
import { registerFeature } from "./registerFeature";
import { features } from "./featuresStore";

featureRegistry.forEach(registerFeature);


export default features;
